import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Transition from 'react-transition-group/Transition';

export function getTransitionProps(props, options) {
  const { timeout, style = {} } = props;

  return {
    duration:
      style.transitionDuration || typeof timeout === 'number' ? timeout : timeout[options.mode],
    delay: style.transitionDelay,
  };
}

export default class Collapse extends Component {
  static propTypes = {
    /** 收缩后剩余高度, 如'5px', '10rem' */
    collapsedHeight: PropTypes.string,
    prefixCls: PropTypes.string,
    /** 是否收缩 */
    in: PropTypes.bool,
    /** 参考react-transition-group/Transition */
    onEnter: PropTypes.func,
    /** 参考react-transition-group/Transition */
    onEntered: PropTypes.func,
    /** 参考react-transition-group/Transition */
    onEntering: PropTypes.func,
    /** 参考react-transition-group/Transition */
    onExit: PropTypes.func,
    /** 参考react-transition-group/Transition */
    onExiting: PropTypes.func,
    /** 动画时间 */
    timeout: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.shape({ enter: PropTypes.number, exit: PropTypes.number }),
      PropTypes.oneOf(['auto']),
    ]),
    /** 动画时间计算方法 function(height: number) => time: number */
    getAutoDuration: PropTypes.func,
  };

  static defaultProps = {
    wrapper: 'div',
    prefixCls: 'ne-collapse',
    timeout: 200,
    collapsedHeight: '0px',
    getAutoDuration: height => height * 2,
  };

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  getWrapper = el => {
    if (el) this.wrapper = el;
  };

  handleEnter = node => {
    node.style.height = this.props.collapsedHeight;

    if (this.props.onEnter) {
      this.props.onEnter(node);
    }
  };

  handleEntering = node => {
    const { timeout, getAutoDuration } = this.props;
    const wrapperHeight = this.wrapper ? this.wrapper.clientHeight : 0;

    const { duration: transitionDuration } = getTransitionProps(this.props, {
      mode: 'enter',
    });

    if (timeout === 'auto') {
      const autoDuration = getAutoDuration(wrapperHeight);
      node.style.transitionDuration = `${autoDuration}ms`;
      this.autoTransitionDuration = autoDuration;
    } else {
      node.style.transitionDuration =
        typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
    }

    node.style.height = `${wrapperHeight}px`;

    if (this.props.onEntering) {
      this.props.onEntering(node);
    }
  };

  handleEntered = node => {
    node.style.height = 'auto';

    if (this.props.onEntered) {
      this.props.onEntered(node);
    }
  };

  handleExit = node => {
    const wrapperHeight = this.wrapper ? this.wrapper.clientHeight : 0;
    node.style.height = `${wrapperHeight}px`;

    if (this.props.onExit) {
      this.props.onExit(node);
    }
  };

  handleExiting = node => {
    const { timeout, getAutoDuration } = this.props;
    const wrapperHeight = this.wrapper ? this.wrapper.clientHeight : 0;

    const { duration: transitionDuration } = getTransitionProps(this.props, {
      mode: 'exit',
    });

    if (timeout === 'auto') {
      const autoDuration = getAutoDuration(wrapperHeight);
      node.style.transitionDuration = `${autoDuration}ms`;
      this.autoTransitionDuration = autoDuration;
    } else {
      node.style.transitionDuration =
        typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
    }

    node.style.height = this.props.collapsedHeight;

    if (this.props.onExiting) {
      this.props.onExiting(node);
    }
  };

  addEndListener = (node, next) => {
    if (this.props.timeout === 'auto') {
      this.timer = setTimeout(next, this.autoTransitionDuration || 0);
    }
  };

  render() {
    const {
      prefixCls,
      timeout,
      children,
      wrapper: Wrapper,
      wrapperProps,
      className,
      collapsedHeight,
      style,
      ...other
    } = this.props;
    return (
      <Transition
        onEntering={this.handleEntering}
        onEnter={this.handleEnter}
        onEntered={this.handleEntered}
        onExiting={this.handleExiting}
        onExit={this.handleExit}
        addEndListener={this.addEndListener}
        timeout={timeout === 'auto' ? null : timeout}
        {...other}>
        {state => (
          <Wrapper
            className={classNames(
              prefixCls,
              {
                [`${prefixCls}-entered`]: state === 'entered',
              },
              className,
            )}
            style={{
              ...style,
              minHeight: collapsedHeight,
            }}
            {...wrapperProps}>
            <div className={`${prefixCls}-wrapper-inner`} ref={this.getWrapper}>
              {children}
            </div>
          </Wrapper>
        )}
      </Transition>
    );
  }
}



// WEBPACK FOOTER //
// ./src/collapse/Collapse.jsx